const USER_STATUSES = {
  INVITED: {display: 'invited', value: 'INVITED', showOrder: 0, def: false},
  ACTIVE: {display: 'active', value: 'ACTIVE', showOrder: 1, def: false},
  NOT_ACTIVE: {display: 'not active', value: 'INACTIVE', showOrder: -1, def: false},
  DISABLED: {display: 'disabled', value: 'DISABLED', showOrder: 2, def: false},
  BLOCKED: {display: 'blocked', value: 'Blocked', showOrder: -1, def: false},
  PENDING: {display: 'pending', value: 'PENDING', showOrder: -2, def: false},
  NOT_EXIST: {display: 'not exist', value: 'NOT EXIST', showOrder: -3, def: false},
};

const RATER_STATUSES = {
  ACTIVE: {display: 'active', value: 'ACTIVE', showOrder: 0, def: false},
  DISABLED: {display: 'disabled', value: 'DISABLED', showOrder: 1, def: false},
};

const COMPANY_STATUSES = {
  ACTIVE:  {display: 'active', value: 'Active', showOrder: 0, def: false},
  NOT_SIGNED:  {display: 'not signed', value: 'Not Signed', showOrder: 1, def: false},
  NOT_ACTIVE:  {display: 'not active', value: 'Deactivated', showOrder: 2, def: false},
  BLOCKED:  {display: 'blocked', value: 'Blocked', showOrder: 3, def: false},
  CANCELLED: {display: 'cancelled', value: 'Cancelled', showOrder: 4, def: false},
  INACTIVE: {display: 'migrated', value: 'Inactive', showOrder: -1, def:false},
  INVITED:  {display: 'invited', value: 'Invited', showOrder: -2, def: false},
  PENDING: {display: 'pending', value: 'Pending', showOrder: -3, def: false},
};

const PERMIT_STATUSES = {
  NEW: {display: 'new', value: 'New', showOrder: 0, def: false},
  COMPLETED: {display: 'completed', value: 'Completed', showOrder: 1, def: false},
  CANCELLED: {display: 'cancelled', value: 'Cancelled', showOrder: 2, def: false},
  HOLD: {display: 'hold', value: 'Hold', showOrder: 3, def: false},
  PENDING: {display: 'pending', value: 'Pending', showOrder: 4, def: false},
  PULLED_NOT_UPLOADED: {display: 'pulled (not uploaded)', value: 'Pulled (not uploaded)', showOrder: 5, def: false},
  APPLIED_FOR_REFUND: {display: 'applied for refund', value: 'Applied For Refund', showOrder: 6, def: false},
  APPOINTMENT_SCHEDULED: {display: 'appointment scheduled', value: 'Appointment Scheduled', showOrder: 7, def: false},
  NOT_REQUIRED: {display: 'not required', value: 'Not Required', showOrder: 8, def: false},
  NEED_ATTENTION: {display: 'needs attention', value: 'Needs Attention', showOrder: 9, def: false},
  SUBMITTED: {display: 'submitted', value: 'Submitted', showOrder: 10, def: false},
  NO_PERMIT_NEEDED: {display: 'no permit needed', value: 'No Permit Needed', showOrder: 11, def: false},
};

const HERS_STATUSES = {
  NEED_ATTENTION: {display: 'needs attention', value: 'Needs Attention', showOrder: 0, def: false},
  COMPLETED: {display: 'completed', value: 'Completed', showOrder: 1, def: false},
  CANCELLED: {display: 'cancelled', value: 'Cancelled', showOrder: 2, def: false},
  SCHEDULED: {display: 'scheduled', value: 'Scheduled', showOrder: 3, def: false},
  READY_TO_RESCHEDULE: {display: 'ready to reschedule', value: 'Ready to Reschedule', showOrder: 4, def: false},
  HOLD_OFF: {display: 'hold off', value: 'Hold Off', showOrder: 5, def: false},
  PENDING: {display: 'pending', value: 'Pending', showOrder: 6, def: false},
  FAILED: {display: 'failed', value: 'Failed', showOrder: 7, def: false},
  RESCHEDULED: {display: 'rescheduled', value: 'Rescheduled', showOrder: 8, def: false},
  EMAILED_DIRECTLY: {display: 'emailed directly', value: 'Emailed Directly', showOrder: 9, def: false},
  NEW: {display: 'new', value: 'New', showOrder: 10, def: false},
  NOT_REQUIRED: {display: 'not required', value: null, showOrder: 11, def: false},
  END_OF_TASK: {display: 'end of task', value: 'End of Task', showOrder: 12, def: false},
};
const MAILING_STATUSES = {
  NEW: {display: 'new', value: 'New', showOrder: 0, def: true},
  //NEED_ATTENTION: {display: 'needs attention', value: 'Needs Attention', showOrder: 0, def: false},
  READY_TO_MAIL: {display: 'ready to mail', value: 'Ready To Mail', showOrder: 1, def: false},
  MAILED: {display: 'mailed', value: 'Mailed', showOrder: 2, def: false},
  REMAILED: {display: 'remailed', value: 'Remailed', showOrder: 3, def: false},
  MAILED_TO_CONTRACTOR: {display: 'mailed to contractor', value: 'Mailed To Contractor', showOrder: 4, def: false},
  EMAILED: {display: 'emailed', value: 'Emailed', showOrder: 5, def: false},
  NO_NEED_TO_MAIL: {display: 'no need to mail', value: 'No Need To Mail', showOrder: 6, def: false},
  CANCEL: {display: 'cancel', value: 'Cancel', showOrder: 7, def: false},
  MAIL_CERT_NEEDED: {display: 'mail cert needed', value: 'Mail Cert Needed', showOrder: 8, def: false},
  CERT_LETTER_MAILED: {display: 'cert letter mailed', value: 'Cert Letter Mailed', showOrder: 9, def: false},
  CERT_LETTER_2_MAILED: {display: 'cert letter 2 mailed', value: 'Cert Letter 2 Mailed', showOrder: 10, def: false},
};

const INSPECTION_STATUSES = {
  NEW: {display: 'New', value: 'New', showOrder: 0, def: true},
  PENDING: {display: 'Pending', value: 'Pending', showOrder: 1, def: false},
  SCHEDULED: {display: 'Final Scheduled', value: 'Scheduled', showOrder: 2, def: false},
  SCHEDULED_ROUGH: {display: 'Rough Scheduled', value: 'Scheduled', showOrder: 3, def: false},
  RESCHEDULED: {display: 'Re Scheduled', value: 'Rescheduled', showOrder: 4, def: false},
  MAILED_CERT_LETTER: {display: 'Mail Certified Letter', value: 'Mail Certified Letter', showOrder: 5, def: false},
  MAILED_CERT_LETTER2: {display: 'Mail Certified Letter 2', value: 'Mail Certified Letter 2', showOrder: 6, def: false},
  MAILED_CERT_LETTER3: {display: 'Mail Certified Letter 3', value: 'Mail Certified Letter 3', showOrder: 7, def: false},
  CANCELLED: {display: 'Cancelled', value: 'Cancelled', showOrder: 8, def: false},
  HOLD: {display: 'Hold', value: 'Hold', showOrder: 9, def: false},
  FAILED: {display: 'Failed', value: 'Failed', showOrder: 10, def: false},
  NO_RESULT: {display: 'No Result', value: 'No Result', showOrder: 11, def: false},
  NEEDS_ATTENTION: {display: 'Needs Attention', value: 'Needs Attention', showOrder: 12, def: false},
  PENDING_CITY_RESPONSE: {display: 'Pending City Response', value: 'Pending City Response', showOrder: 13, def: false},
  FUTURE_DATE: {display: 'Future Date', value: 'Future Date', showOrder: 14, def: false},
  CUSTOMER_DECLINED: {display: 'Customer Declined', value: 'Customer Declined', showOrder: 15, def: false},
  COMPLETED: {display: 'Completed', value: 'Completed', showOrder: 17, def: false},
  AI_READY: {display: 'AI Ready', value: 'AI Ready', showOrder: 18, def: false},
  AI_IN_PROGRESS: {display: 'AI In Progress', value: 'AI In Progress', showOrder: 19, def: false},
  AI_VERIFY: {display: 'AI Verify', value: 'AI Verify', showOrder: 20, def: false},
  AI_CLOSED_OUT: {display: 'AI Closed Out', value: 'AI Closed Out', showOrder: 21, def: false},
};

const AI_INSPECTION_STATUSES = {
  NOT_ALLOWED: {display: 'Not Allowed', value: 'Not Allowed', showOrder: 1, def: false},
  NOT_READY: {display: 'Not Ready', value: 'Not Ready', showOrder: 2, def: false},
  READY: {display: 'Ready', value: 'Ready', showOrder: 3, def: false},
  IN_PROGRESS: {display: 'In Progress', value: 'In Progress', showOrder: 4, def: false},
  RESCHEDULED: {display: 'Rescheduled', value: 'Rescheduled', showOrder: 5, def: false},
  VERIFY: {display: 'Verify', value: 'Verify', showOrder: 6, def: false},
  CLOSED_OUT: {display: 'Closed Out', value: 'Closed Out', showOrder: 8, def: false},
};

const AI_CALL_PRIORITIES = {
  URGENT: {display: 'Urgent', value: '10', showOrder: 1, def: false},
  HIGH: {display: 'High', value: '20', showOrder: 2, def: false},
  NORMAL: {display: 'Normal', value: '30', showOrder: 3, def: false},
};

const SERVICE_TITAN_STATUSES = {
  FAILED: {display: 'Failed', value: 'Failed', showOrder: 0, def: true},
  CREATED: {display: 'Created', value: 'Created', showOrder: 1, def: false},
  DELETED: {display: 'Deleted', value: 'Deleted', showOrder: 2, def: true},
  IGNORED: {display: 'Ignored', value: 'Ignored', showOrder: 3, def: false},
  DOCUMENTUPLOADED: {display: 'Document Uploaded', value: 'Document Uploaded', showOrder: 4, def: false},

}

// Zoho Scheduling module statuses, stored on the job as-is (internal only).
const SCHEDULING_STATUSES = {
  PENDING: {display: 'Pending', value: 'Pending', showOrder: 0, def: false},
  SCHEDULED: {display: 'Scheduled', value: 'Scheduled', showOrder: 1, def: false},
  RESCHEDULED: {display: 'Rescheduled', value: 'Rescheduled', showOrder: 2, def: false},
  HOLD_OFF: {display: 'Hold Off', value: 'Hold Off', showOrder: 3, def: false},
  MAIL_FIRST_LETTER: {display: 'Mail First Letter', value: 'Mail First Letter', showOrder: 4, def: false},
  HERS_REQUEST_DETAILS: {display: 'HERS Request Details', value: 'HERS Request Details', showOrder: 5, def: false},
  CANCELLED: {display: 'Cancelled', value: 'Cancelled', showOrder: 6, def: false},
  MAIL_CERT_LETTER: {display: 'Mail Cert Letter', value: 'Mail Cert Letter', showOrder: 7, def: false},
  MAIL_CANCEL: {display: 'Mail Cancel', value: 'Mail Cancel', showOrder: 8, def: false},
  NEW: {display: 'New', value: 'New', showOrder: 9, def: false},
  PAST_DUE: {display: 'Past Due', value: 'Past Due', showOrder: 10, def: false},
  MECH_01: {display: 'MECH 01', value: 'MECH 01', showOrder: 11, def: false},
  REVISE_PERMIT: {display: 'Revise Permit', value: 'Revise Permit', showOrder: 12, def: false},
};

export {USER_STATUSES,
  COMPANY_STATUSES,
  PERMIT_STATUSES,
  HERS_STATUSES,
  MAILING_STATUSES,
  INSPECTION_STATUSES,
  RATER_STATUSES,
  SERVICE_TITAN_STATUSES,
  AI_INSPECTION_STATUSES,
  AI_CALL_PRIORITIES,
  SCHEDULING_STATUSES,
};
